export function formatPrice(upfrontPrice, lang) {
    var formatter = new Intl.NumberFormat(lang === 'en' ? 'en-US' : 'fr-CA', {
        style: 'currency',
        currency: 'CAD',
        currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: 2
    });
    // The formatter will now only use the narrow symbol (e.g., "$") without the currency code
    return formatter.format(upfrontPrice);
}
